document.addEventListener('DOMContentLoaded', () => {
  const homeSlide = document.getElementById('homeSlide');

  if (!homeSlide) return;

  const slideCount = homeSlide.querySelectorAll('.splide__slide').length;
  let splide = null;

  const options = {
    type: 'loop',
    perPage: 3,
    autoplay: true,
    interval: 3500,
    speed: 500,
    easing: 'cubic-bezier(0,1,.75,1.1)',
    gap: '24px',
    focus: 'center',
    pagination: false,

    breakpoints: {
      840: {
        perPage: 1,
        focus: 0,
      },
      640: {
        perPage: 1,
        arrows: false,
        pagination: true,
      },
    },
  };

  function setupHomeSlide() {
    const isPc = window.matchMedia('(min-width: 641px)').matches;
    const shouldStatic = slideCount <= 3 && isPc;

    if (shouldStatic) {
      homeSlide.classList.add('is-static');
      homeSlide.classList.remove('is-slider');

      if (splide) {
        splide.destroy();
        splide = null;
      }
    } else {
      homeSlide.classList.add('is-slider');
      homeSlide.classList.remove('is-static');

      if (!splide) {
        splide = new Splide(homeSlide, options);
        splide.mount();
      }
    }
  }

  setupHomeSlide();

  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      setupHomeSlide();
    }, 200);
  });
});

//泡
document.addEventListener('DOMContentLoaded', () => {
  // 泡を表示したい開始位置
  const start = document.querySelector('.movieRecommend') || document.querySelector('.movieRecently');

  // 泡を表示したい終了位置
  const end = document.querySelector('footer');

  if (!start || !end) return;

  const bubbleLayer = document.createElement('div');
  bubbleLayer.className = 'bubbleLayer';
  document.body.appendChild(bubbleLayer);

  function updateBubbleArea() {
    const top = start.offsetTop;
    const bottom = end.offsetTop + end.offsetHeight;

    bubbleLayer.style.top = `${top}px`;
    bubbleLayer.style.height = `${bottom - top}px`;
  }

  function createBubble() {
    if (bubbleLayer.children.length >= 8) return;

    const bubble = document.createElement('span');
    bubble.classList.add('bubble');

    const isSp = window.innerWidth <= 768;
    const size = isSp ? Math.random() * 20 + 10 : Math.random() * 40 + 20;
    const left = Math.random() * 100;
    const top = Math.random() * 70 + 30;
    const duration = Math.random() * 4 + 5;
    const moveX = Math.random() * 80 - 40;

    bubble.style.left = `${left}%`;
    bubble.style.top = `${top}%`;
    bubble.style.setProperty('--size', `${size}px`);
    bubble.style.setProperty('--duration', `${duration}s`);
    bubble.style.setProperty('--moveX', `${moveX}px`);

    bubbleLayer.appendChild(bubble);

    bubble.addEventListener('animationend', () => {
      bubble.remove();
    });
  }

  updateBubbleArea();
  setTimeout(updateBubbleArea, 500);
  setTimeout(updateBubbleArea, 1500);
  setTimeout(updateBubbleArea, 3000);

  window.addEventListener('resize', updateBubbleArea);

  let bubbleTimer = null;

  function startBubble() {
    if (bubbleTimer) return;

    bubbleTimer = setInterval(() => {
      createBubble();
    }, 2000);
  }

  function stopBubble() {
    clearInterval(bubbleTimer);
    bubbleTimer = null;

    bubbleLayer.querySelectorAll('.bubble').forEach((bubble) => {
      bubble.remove();
    });
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopBubble();
    } else {
      updateBubbleArea();
      startBubble();
    }
  });

  startBubble();
});
